export default {
  'status': 'Translation validated by country',
  'meta': {
    'lang': 'Nederlands'
  },
  'title': 'TERUGROEPACTIE SIMOND QUICKDRAWS ALPINISM / VERTIKA',
  'homepage': {
    'notice': 'Terugroepactie. Belangrijke informatie over de veiligheid en uitrusting.',
    'purchaseWindow': 'Je hebt een ALPINISM en/of VERTIKA karabiner gekocht tussen 1 januari 2022 en 23 juli 2026.',
    'skus': 'Alpinism 11 cm Quickdraw (4051175 / 8589547)\nAlpinism 17 cm Quickdraw (4051176 / 8589548)\nSet van 5 Alpinism Quickdraws (4171656 / 8608405)\nVertika 11 cm Quickdraw (5499689 / 8935765)\nVertika 17 cm Quickdraw (5500194 / 8935909)',
    'responsibility': 'Omdat de veiligheid van onze klanten onze hoogste prioriteit heeft, informeren wij je over een belangrijke veiligheidswaarschuwing voor de quickdraws die zijn uitgerust met de Rocky Fil-karabiner.',
    'defect': 'Er is een fabricagefout ontdekt bij de sluiting van de karabiner. Hierdoor kan de sluiting breken. Als de sluiting breekt, verliest de karabiner een groot deel van zijn sterkte. Bij een val kan de gehele karabiner daardoor breken, wat een direct risico geeft op vallen met ernstig of dodelijk letsel.',
    'stopUsing': 'Stop direct met het gebruik van dit product totdat je de onderstaande controle hebt uitgevoerd.'
  },
  'procedure': {
    'stopUsing': 'Stop direct met het gebruik van het product en controleer aan de hand van de onderstaande instructies of jouw karabiner door dit defect is getroffen.',
    'title': 'Hoe je dit product kunt controleren:',
    'intro': 'Controleer of beide zijden van de draadsluiting stevig aan de karabiner vastzitten:',
    'step1': 'Pak de karabiner aan één kant vast en plaats je duim tussen de twee draden (met je duim zo dicht mogelijk bij het klinknageltje). Druk stevig naar beneden tegen de karabiner.',
    'step2': 'Draai de karabiner om en herhaal dezelfde handeling aan de andere kant van de draadsluiting.'
  },
  'outcome': {
    'nok': {
      'body': 'Na inspectie is gebleken dat de draad losgeraakt is: Stop onmiddellijk met het gebruik van het product en breng het terug naar de dichtstbijzijnde Decathlon-winkel. Ons team zal het defecte product in behandeling nemen en de volledige terugbetaling voor deze teruggeroepen artikelen direct verwerken.',
      'support': 'Onze klantenservice staat voor je klaar op 085 0003 637 (ma-za van 09:00 tot 12:00). Of kijk voor meer informatie op: https://help.decathlon.nl/hc/nl'
    },
    'ok': {
      'body': 'Na controle blijkt dat de draad niet uit de behuizing komt: Het product ondervindt geen hinder van dit defect en je kunt het blijven gebruiken.'
    }
  },
  'buttons': {
    'ok': 'Mijn product is OK',
    'nok': 'Mijn product is niet OK'
  }
} as const
